import type { Article } from "@/mocks/articles";

interface Props {
  article: Article;
}

export default function ArticleContent({ article }: Props) {
  return (
    <div
      className="max-w-3xl mx-auto"
      style={{ fontFamily: "'Noto Serif TC', serif" }}
    >
      {article.sections.map((section, i) => {
        if (section.type === "heading") {
          return (
            <h4
              key={i}
              id={`section-${i}`}
              className="text-[#2d2520] font-bold mt-12 mb-5 leading-[1.45]"
              style={{ fontSize: "clamp(1.25rem, 2vw, 1.625rem)" }}
            >
              <a href={`#section-${i}`} className="hover:text-[#8b6f47] transition-colors">
                {section.content}
              </a>
            </h4>
          );
        }

        if (section.type === "paragraph") {
          return (
            <p
              key={i}
              className="text-[#5a4e45] leading-[1.75] mb-6"
              style={{ fontSize: "1.1875rem" }}
            >
              {section.content}
            </p>
          );
        }

        if (section.type === "quote") {
          return (
            <blockquote
              key={i}
              className="my-10 pl-6 border-l-4 border-[#c9a96e]"
            >
              <p
                className="text-[#5a4e45] italic leading-[1.75]"
                style={{ fontSize: "1.1875rem" }}
              >
                {section.content}
              </p>
            </blockquote>
          );
        }

        if (section.type === "list" && section.items) {
          return (
            <ul key={i} className="mb-6 space-y-3">
              {section.items.map((item, j) => (
                <li key={j} className="flex gap-3 items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#8b6f47] mt-3 flex-shrink-0"></span>
                  <span
                    className="text-[#5a4e45] leading-[1.75]"
                    style={{ fontSize: "1.1875rem" }}
                  >
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          );
        }

        if (section.type === "divider") {
          return (
            <div key={i} className="flex items-center gap-4 my-10">
              <span className="flex-1 h-px bg-[#e8e0d5]"></span>
              <i className="ri-sparkling-2-line text-[#c9a96e]"></i>
              <span className="flex-1 h-px bg-[#e8e0d5]"></span>
            </div>
          );
        }

        return null;
      })}
    </div>
  );
}
